<div class="image-upload-wrap min-h-[85px] h-auto bg-no-repeat bg-center relative text-center">
	<img [src]="image" style="max-width: 100%" />
	<input class="absolute m-0 p-0 w-full h-full outline-none opacity-0 cursor-pointer top-0 left-0 hover:opacity-100 z-20" name="file" type="file" accept="image/*" size="1000000" (change)="onImageChanged($event)" #createEventFileInput />

	<div class="absolute top-0 w-full h-full flex flex-col justify-center items-center opacity-100 text-[#b4b4b4]" *ngIf="!image" [class.--overlay]="!!image">
		<p style="line-height: 1" class="text-[10px] font-thin p-2.5 hover:cursor-pointer">
			<img class="my-0 mx-auto w-[100px] text-[45px] flex justify-center" src="assets/images/image.png" />
			Drag and drop a file or click to choose an image.
		</p>
	</div>

	<mat-icon class="file-edit-icon z-40" *ngIf="image" (click)="createEventFileInput.click()">edit</mat-icon>
	<mat-icon class="file-edit-icon delete-icon z-40" *ngIf="image" (click)="clearImageOnClick()">delete</mat-icon>
	<ng-template #defaultUpdateImagePicker>
		<button [disableRipple]="true" class="file-upload-btn" (click)="createEventFileInput.click()" value="Choose Image"></button>
	</ng-template>
</div>

<ng-template #fileUploadExceedDialog>
	<mat-toolbar>
		<button [disableRipple]="true" matDialogClose class="close" mat-icon-button>
			<mat-icon>cancel</mat-icon>
		</button>
	</mat-toolbar>
	<mat-dialog-content style="max-width: 340px; min-width: 250px; width: auto; height: auto; padding: 0px">
		<div class="image-section" color="primary">
			<div class="action-content">
				<div class="action-image">
					<img src="assets/images/file-size-limit-exceeded.png" />
				</div>
				<div class="action-title">
					<h2>File size limit exceeded.</h2>
				</div>
				<div class="action-message">
					<h5>Maximum allowed size is 10MB.</h5>
				</div>
			</div>
		</div>
	</mat-dialog-content>
</ng-template>
